import React, { PureComponent } from 'react';
import Snackbar, { getSnackbarType } from '@atoms/Snackbar';

export class GlobalSnackbar extends PureComponent {
  render() {
    return (
      <Snackbar
        open={this.props.isVisible}
        message={this.props.message}
        type={getSnackbarType(this.props.success)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/atoms/GlobalSnackbar/GlobalSnackbar.js